(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      var tabs = document.querySelectorAll('.tab-icon');
      var contents = document.querySelectorAll('.tab-content');

      // Show the first content by default
      document.querySelector('.tab-content.active').style.display = 'block';

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var tabId = this.getAttribute('data-tab');

          // Remove active class from all tabs and hide all content
          tabs.forEach(function(t) {
            t.classList.remove('active');
          });
          contents.forEach(function(content) {
            content.style.display = 'none';
            content.classList.remove('active');
          });

          // Add active class to the clicked tab and show its content
          this.classList.add('active');
          var contentToShow = document.getElementById('tab-content-' + tabId);
          contentToShow.style.display = 'block';
          contentToShow.classList.add('active');
        });
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tab"] && !Shopify.designMode) return;
  try {
    
tabs = document.querySelectorAll('.custom-tab');
tabContents = document.querySelectorAll('.custom__tab-content');

tabs.forEach(function(tab) {
  tab.addEventListener('click', function() {
    contentId = this.dataset.contentId;
    content = document.getElementById(contentId);

    tabContents.forEach(function(content) {
      content.classList.remove('active');
    });

    tabs.forEach(function(tab) {
      tab.classList.remove('active');
    });

    this.classList.add('active');
    content.classList.add('active');
  });
});

// Accordion functionality
var acc = document.getElementsByClassName("accordion");
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["detail-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
      // Select all tabs and tab content elements
      const tabs = document.querySelectorAll('.custom-tab');
      const tabContents = document.querySelectorAll('.custom__tab-content');

      // Function to remove 'active' class from all tabs and tab contents
      function removeActiveClasses() {
          tabContents.forEach(function(content) {
              content.classList.remove('active');
          });
          tabs.forEach(function(tab) {
              tab.classList.remove('active');
          });
      }

      // Function to activate the first tab and its content
      function activateFirstTab() {
          tabs[0].classList.add('active');
          tabContents[0].classList.add('active');
      }

      // Set the first tab as active by default
      activateFirstTab();

      // Add click event listeners to each tab
      tabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
              const contentId = this.dataset.contentId;
              const content = document.getElementById(contentId);

              // Remove active classes from all tabs and contents
              removeActiveClasses();

              // Add active class to the clicked tab and its corresponding content
              this.classList.add('active');
              content.classList.add('active');
          });
      });
  });



  document.addEventListener("DOMContentLoaded", function () {
    const titles = document.querySelectorAll('.accordion-title');

    titles.forEach(function (title) {
      title.addEventListener('click', function () {
        const item = this.parentElement; // Current accordion item
        const icon = this.querySelector('.accordion-icon');
        const content = this.nextElementSibling; // The associated content

        // Toggle current item
        const isActive = item.classList.contains('active');
        item.classList.toggle('active');
        content.style.display = isActive ? 'none' : 'block';
        icon.textContent = isActive ? '+' : '-';

        // Close other items
        document.querySelectorAll('.accordion-item').forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
            otherItem.querySelector('.accordion-title .accordion-icon').textContent = '+';
            otherItem.querySelector('.accordion-content').style.display = 'none';
          }
        });
      });
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
      // Select all accordion items
      const accordionItems = document.querySelectorAll('.accordion-item-in');

      // Loop through each accordion item
      accordionItems.forEach(function (item) {
          const title = item.querySelector('.accordion-title-in');
          const content = item.querySelector('.accordion-content-in');
          const icon = item.querySelector('.accordion-icon-in');

          // Add click event listener to the title
          title.addEventListener('click', function () {
              // Check if the content is currently displayed
              const isOpen = content.style.display === 'block';

              // Close all other accordion items
              accordionItems.forEach(function (otherItem) {
                  const otherContent = otherItem.querySelector('.accordion-content-in');
                  const otherIcon = otherItem.querySelector('.accordion-icon-in');
                  otherContent.style.display = 'none';
                  otherIcon.textContent = '+';
              });

              // Toggle the clicked accordion item
              if (isOpen) {
                  content.style.display = 'none';
                  icon.textContent = '+';
              } else {
                  content.style.display = 'block';
                  icon.textContent = '-';
              }
          });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  const headings = document.querySelectorAll('.grid .footer-block__heading');

  const handleCollapse = (heading) => {
    const content = heading.nextElementSibling;

    if (heading.classList.contains('block-collapsed')) {
      heading.classList.remove('block-collapsed');
      heading.setAttribute('aria-expanded', 'true');
      content.style.display = 'block'; // or any other preferred display property
    } else {
      heading.classList.add('block-collapsed');
      heading.setAttribute('aria-expanded', 'false');
      content.style.display = 'none';
    }
  };

  headings.forEach((heading, index) => {
    heading.classList.add('block-collapsed');
    heading.setAttribute('role', 'button');
    heading.setAttribute('aria-expanded', 'false');
    heading.setAttribute('tabindex', '0');

    const content = heading.nextElementSibling;
    content.setAttribute('id', `footer-block-index-${index}`);
    heading.setAttribute('aria-controls', `footer-block-index-${index}`);

    heading.addEventListener('click', () => {
      handleCollapse(heading);
    });

    heading.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        handleCollapse(heading);
      }
    });
  });
});

document.querySelector("#footer-block-index-1 li:last-child a").setAttribute("target", "_blank");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.getElementByClass('tmenu-watermark').style.display = 'none';
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function(){
    var slider = $('.responsive');
    slider.slick({
      slidesToShow: 3.2,
      infinite: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
           slidesToShow: 50,
            dots: false
          }
        }
      ]
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mansoon"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    var slider = $('.product-slider');
    slider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 100,
            dots: false
          }
        }
      ]
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundler"] && !Shopify.designMode) return;
  try {
    
Shopify.blockRefresh = {
  onSectionLoad: function() {},
  onSectionUnload: function() {},
  onBlockSelect: function() {},
  onBlockDeselect: function() {},
  onLoad: function() {}
}

  } catch(e) { console.error(e); }
})();
})();
